import type { TourConfig } from '../../types/tour.types'

// Ignored Leads (Purchase History). The page header carries a `data-tour` anchor added
// alongside this tour; the filter bar and table target stable classes rendered by
// IgnoredLeadsTable. The Remove action column is admin-only, so that step is optional.
const ignoredLeadsTour: TourConfig = {
  id: 'ignored-leads',
  title: 'Keep the leads you dismissed out of the way',
  module: 'Purchase History',
  routeName: 'IgnoredLeads',
  order: 15,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'The leads you chose to set aside',
      body: 'When a company is not a fit, you can **ignore** it so it stops showing up in your searches and results. This page is the full list of everything you have pushed out of the way — so your prospecting stays focused on real opportunities.',
    },
    {
      id: 'header',
      target: '[data-tour="il-header"]',
      placement: 'bottom',
      title: 'Your ignored leads',
      body: 'Every company here is **hidden from your results** on purpose. Review the list to confirm you have not set aside something worth revisiting.',
    },
    {
      id: 'filter',
      target: '.il-filter-bar',
      placement: 'bottom',
      title: 'Find a specific ignored lead',
      body: 'Filter by **date range** and hit **Find** to pinpoint when a company was ignored — useful when the list grows long.',
    },
    {
      id: 'table',
      target: '.il-table-card',
      placement: 'top',
      title: 'Check what you excluded',
      body: 'Each row shows the **date** and **company URL** you ignored. Open the link to double-check the company before deciding whether it belongs back in your pipeline.',
    },
    {
      id: 'remove',
      target: '.il-table-card .text-none',
      placement: 'start',
      // The Remove action column is only rendered for admins.
      optional: true,
      title: 'Bring a lead back',
      body: 'Changed your mind? **Remove** an entry to un-ignore that company so it can appear in your searches and results again.',
    },
  ],
}

export default ignoredLeadsTour
